module.exports = __webpack_public_path__ + "f49270d0a276797c299d001c5782cf7f.png";